import { Box, VStack, Text, Button, Icon } from "@chakra-ui/react";
import { InfoOutlineIcon } from "@chakra-ui/icons";

export default function NoFeeds({ month, year }) {
  const monthName = new Date(2000, month - 1).toLocaleString("default", {
    month: "long",
  });
  return (
    <Box
      w="100%"
      minH="60vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="gray.50"
      px={4}
      py={10}
    >
      <Box
        maxW="sm"
        w="full"
        textAlign="center"
        p={6}
        rounded="xl"
        shadow="md"
        bg="white"
      >
        <VStack spacing={3}>
          <Icon as={InfoOutlineIcon} boxSize={6} color="gray.400" />
          <Text fontSize="md" fontWeight="semibold" color="gray.800">
            No feeds / activity found
          </Text>
          <Text fontSize="sm" color="gray.600">
            for the month {monthName}-{year}. Please select a different month.
          </Text>
        </VStack>
      </Box>
    </Box>
  );
}
